// extracted by mini-css-extract-plugin
export default {"keyDatesContainer":"VDPDaQpulzi8EEEedb8c","links":"GRynngVEpo4RrnY47nV1","link":"IjDesS0FCd63pQBIGLIg","linkIcon":"MtdioWMklSEliMj6SkHU"};